<template>
  <SignupBody/>
</template>

<script>
// @ is an alias to /src
import SignupBody from '@/components/SignupBody.vue'

export default {
  name: 'SignupView',
  components: {
    SignupBody
  }
}
</script>
